import { ThemeHeaderPicker } from './ThemeHeaderPicker'
import { ThemeSegment } from './ThemeSegment'

/** 视口 ≤ 此宽度时用收纳按钮，否则顶栏展示 compact 横条（可横滑） */
export const THEME_HEADER_PICKER_MAX_PX = 420

const compactScrollWrap =
  'theme-segment-compact-scroll min-w-0 max-w-[min(100%,18.5rem)] overflow-x-auto overflow-y-hidden overscroll-x-contain [-webkit-overflow-scrolling:touch] max-[420px]:hidden'

type Props = {
  className?: string
}

/**
 * 壳层顶栏右侧主题区：≤420px 收纳，更宽则 compact 横条（App / 登录页共用）。
 */
export function ThemeMobileHeaderControl({ className = '' }: Props) {
  return (
    <div className={['shrink-0 min-w-0', className].filter(Boolean).join(' ')}>
      <div className="hidden max-[420px]:block">
        <ThemeHeaderPicker />
      </div>
      <div className={compactScrollWrap}>
        <ThemeSegment compact nowrap />
      </div>
    </div>
  )
}
